export default "__VITE_ASSET__ce94beae__"